export default __webpack_public_path__ + "static/media/bs_1.c0ad4492.jpg";